import {FC} from 'react'
import {Form} from 'react-bootstrap'
import {OecdDescription} from '../../oecd-descriptions/core/_models'

type Props = {
  oecdDescriptionDetail: OecdDescription
}

const OecdDescriptionsDetailView: FC<Props> = ({oecdDescriptionDetail}) => {
  const renderValue = (value?: string | number | null) => {
    if (value === null || value === undefined || value === '') return '-'
    return String(value)
  }

  return (
    <div className='detail-oecd-description'>
      <div className='row mb-4'>
        <div className='col-md-12 mb-3'>
          <Form.Label>Code</Form.Label>
          <div className='data-value fw-semibold'>{renderValue(oecdDescriptionDetail.code)}</div>
        </div>
        <div className='col-md-12 mb-3'>
          <Form.Label>Description</Form.Label>
          <div className='data-value' style={{whiteSpace: 'pre-wrap'}}>
            {renderValue(oecdDescriptionDetail.desc)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OecdDescriptionsDetailView
